import React, { useState,useEffect  } from 'react';
import { Container, Title, SearchArea, ButtonContainer, BlueButton } from '../Labels/styled';
import { useDispatch, useSelector } from 'react-redux';
import { avaliacaoFinalAdd } from '../../../../../Services/cardService';
import { Input } from '@mui/material';

const AvaliacaoFinalPopover = (props) => {
	const dispatch = useDispatch();
	const thisCard = useSelector((state) => state.card);
	
	const [n1, setN1] = useState(thisCard.avaliacaoFinal?.n1 || '');
	const [n2, setN2] = useState(thisCard.avaliacaoFinal?.n2 || '');
	const [n3, setN3] = useState(thisCard.avaliacaoFinal?.n3 || '');
	const [observacao, setObservacao] = useState(thisCard.avaliacaoFinal?.observacao || '');

	const handleAddClick = async () => {				
			await avaliacaoFinalAdd(thisCard.cardId, thisCard.listId, thisCard.boardId, n1, n2, n3, observacao , dispatch)
			props.closeCallback();
	};

	useEffect(() => {
		setN1(thisCard.avaliacaoFinal?.n1 || '');
		setN2(thisCard.avaliacaoFinal?.n2 || '');
		setN3(thisCard.avaliacaoFinal?.n3 || '');
		setObservacao(thisCard.avaliacaoFinal?.observacao || '');
	}, [thisCard]);


	return (
		<Container>
			<Title>Nota 1</Title>
			<Input
				placeholder="N1..."
				value={n1}
				onChange={(e) => {
					const value = e.target.value;
					// Permitir apenas números decimais
					if (/^\d*\.?\d*$/.test(value)) {
						setN1(value);
					}
				}}
			/>
      <Title>Nota 2</Title>
			<Input
				placeholder="N2..."
				value={n2}
				onChange={(e) => {
					const value = e.target.value;
					// Permitir apenas números decimais
					if (/^\d*\.?\d*$/.test(value)) {
						setN2(value);
					}
				}}
			/>
      <Title>Nota 3</Title>
			<Input
				placeholder="N3..."
				value={n3}				
				onChange={(e) => {
					const value = e.target.value;
					// Permitir apenas números decimais
					if (/^\d*\.?\d*$/.test(value)) {
						setN3(value);
					}
				}}
			/>
      <Title>Observação</Title>
			<SearchArea placeholder='Observação...' value={observacao} onChange={(e) => setObservacao(e.target.value)} />
			
			<ButtonContainer>
				<BlueButton style={{ width: '5.2rem' }} onClick={handleAddClick}>
					Adicionar
				</BlueButton>
			</ButtonContainer>
		</Container>
	);
};

export default AvaliacaoFinalPopover;
